type RouteObject = {
  [key: string]: {
    name: string;
    path: string;
    getUrl: (_params: any) => string;
  };
};

type Route = {
  name: string;
  path: string;
  exact?: boolean;
  isGlobal?: boolean;
};

function wrapRoutes(routes: Route[]): RouteObject {
  const routesObj = {} as RouteObject;

  routes.forEach((route, index) => {
    const routeName = route.name || index;
    routesObj[routeName] = {
      ...route,
      getUrl(...params: any) {
        let paramIdx = 0;
        const pathChunk = route.path.split("/").map((chunk) => {
          return chunk.charAt(0) === ":" ? params[paramIdx++] : chunk;
        });
        return "/" + pathChunk.filter(Boolean).join("/");
      }
    };
  });

  return routesObj;
}

export default wrapRoutes;
